import React from 'react';
import { ResponsivePie } from '@nivo/pie';
import '../../pages/pages/audience/Audience.css'

import generation from "../../assets/images/generation.png"
import gender from "../../assets/images/gender.png"
import earth from "../../assets/images/earth.png"
import finance from "../../assets/images/hand.png"

const icons = {
    'Gender Ratio': gender,
    'Generation Ratio': generation,
    'Location Ratio': earth,
    'Purchasing Power': finance
};
const color = ['#ff6b9c', '#65c6ff', '#fff370', '#ff8264', '#a3ff50','#a3ff50']

const customTooltip = ({ datum }) => (
    <div style={{ background: 'white', padding: '10px', border: '1px solid #ccc' }}>
        <strong>{datum.id}: %{datum.value} </strong>
    </div>
);

const PieChart = ({ data, title }) => {

    const commonPieProps = {
        colors: color,
        sortByValue: true,
        innerRadius:0.4,
        startAngle: -65,
        arcLabelsSkipAngle: 10,
        arcLinkLabelsOffset: 0,
        arcLinkLabelsSkipAngle: 10,
        arcLinkLabelsDiagonalLength: 4,
        arcLinkLabelsStraightLength:1,
        arcLinkLabelsThickness:2,
         tooltip: customTooltip,
        enableArcLinkLabels: true,
        arcLabelsTextColor: {
            from: 'color',
            modifiers: [
                ['darker', '3']
            ]
        },
        theme: {
            labels: {
                text: {
                    fontSize: 12,
                    fontWeight: 'bold',
                },
            },
        },
        arcLabel: e => {
            const formattedValue = parseFloat(parseFloat(e.value).toFixed(1));
            return `${formattedValue}%`;
        },
                isInteractive: true,

    };

    return (
        <div className="pie-container">
            <div className="chart-title" >
                <img src={icons[title]} alt={`${title} icon`} className="chart-icon" />
                <div className="spacer"></div> 
                <h5 className="chart-text">{title}</h5>
                
            </div>
            <ResponsivePie   data={data} {...commonPieProps} />
            
        </div>
    );
};

export default PieChart;
